<template>
  <div class="bg-white rounded-lg shadow p-6">
    <h3 class="text-lg font-semibold text-gray-800">
      {{ title }}
    </h3>
    <div class="panel-body">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th
                    v-for="(header, index) in headers"
                    :key="index"
                    scope="col"
                    class="table-header-cell"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row" v-for="(row, r_idx) in rows" :key="r_idx">
                  <td
                    v-for="(cell, c_idx) in row.values"
                    :key="c_idx"
                    :class="row.main ? 'table-cell-main' : 'table-cell'"
                  >
                    {{ cell }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowProcessDataTable",
  components: {},
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    }
  },
  created() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>
